import React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { useTranslation } from 'react-i18next';
import { confirmButtonStyle, useStyles } from './styles';
import CLOSE_ICON from '../../assets/svg/close-icon.svg';
import Button from '../Button/Button';
import WarningIcon from '@mui/icons-material/Warning';
import { Dialog } from '@mui/material';
import { LANG_TEXT } from '../../constants/language';

interface ModalCustomProps {
  open: boolean;
  handleClose: () => void;
  title: string;
}

const WarningModal: React.FC<ModalCustomProps> = ({ open, handleClose, title }) => {
  const classes = useStyles();
  const { t } = useTranslation();

  return (
    <Dialog className={classes.Modal} open={open} onClose={handleClose} aria-labelledby="modal-modal-title" aria-describedby="modal-modal-description">
      <Box className={classes.Box}>
        <Box className={classes.BoxHeader}>
          <Box className={classes.BoxTitleModal}>
            <Box className={classes.TitleModal}>
              <Box className={classes.DeleteIcon}>
                <WarningIcon height={24} width={24} color="warning" />
              </Box>
              <Typography fontSize={18} fontWeight={600} lineHeight={'28px'} color={'var(--Gray-900, #101828)'}>
                {t(LANG_TEXT.CONTINUE_UPDATE)}
              </Typography>
            </Box>
            <Box className={classes.Icon} onClick={handleClose}>
              <img src={CLOSE_ICON} height={20} width={20} alt="CLOSE_ICON" />
            </Box>
          </Box>
        </Box>
        <Box className={classes.BoxContent}>
          <Typography fontSize={14} lineHeight={'20px'} color={'var(--Gray-600, #475467)'}>
            {title}
          </Typography>
        </Box>
        <Box className={classes.BoxFooter}>
          <Button
            id="confirm_button"
            fullWidth={false}
            title={t(LANG_TEXT.CONFIRM)}
            buttonStyle={confirmButtonStyle}
            sxTextStyle={{ color: 'var(--Base-White, #FFF)', fontSize: '16px', fontWeight: 600, lineHeight: '24px' }}
            onClick={() => {
              handleClose();
            }}
          />
        </Box>
      </Box>
    </Dialog>
  );
};

export default WarningModal;
